import type ScheduleBoardWorkOrderViewModel from 'ab-socketModels/viewModels/scheduleBoard/scheduleBoardWorkOrder.viewModel';

export const isValidScheduleBoardWorkOrder = (values: ScheduleBoardWorkOrderViewModel) => {
	const errors: ValidationErrors = {};

	if (!values.supervisorId) {
		errors.supervisorId = 'Superintendent is required';
	}

	if (!values.dueDate) {
		errors.dueDate = 'Date of work is required';
	}

	if (!values.jobCode) {
		errors.jobId = 'Job is required';
	}

	if (!values.isInternal && !values.crewTypeId) {
		errors.crewTypeId = 'Crew type is required';
	}

	if (values.isInternal && !(values.customCrewType?.trim())) {
		errors.customCrewType = 'Crew type is required';
	}

	if (!values.shift) {
		errors.shift = 'Shift is required';
	}

	return {
		isValid: Object.keys(errors).length === 0,
		errors,
	};
};

export const InvalidWorkOrderModalReasons = {
	delayReason: 'Delay Reason',
	supervisorId: 'Supervisor',
	crewTypeId: 'Crew Type',
	addresses: 'Address',
	workOrderTasks: 'Task',
};

